import { render, staticRenderFns } from "./jobInfo.vue?vue&type=template&id=c70cfd46"
import script from "./jobInfo.vue?vue&type=script&lang=js"
export * from "./jobInfo.vue?vue&type=script&lang=js"
import style0 from "./jobInfo.vue?vue&type=style&index=0&id=c70cfd46&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports